/* PricingTiersSkeleton.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Stripe } from '@atlassian/mpac-primitives';
import React from 'react';
import { PricingDescription } from '../PricingTab.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _5 = "._1bah1h6o{justify-content:center}";
const _4 = "._p12ff10v{max-width:49.375rem}";
const _3 = "._1n261g80{flex-wrap:wrap}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._18s81mxl{margin:var(--ds-space-250,20px) auto}";
export const PricingTierRowSkeleton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s81mxl _1e0c1txw _1n261g80 _p12ff10v _1bah1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingTierRowSkeleton.displayName = 'PricingTierRowSkeleton';
}
const PricingTiersSkeleton = _ref2 => {
  let {
    showServerEolMessage
  } = _ref2;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!showServerEolMessage ? /*#__PURE__*/_jsx(PricingDescription, {
      children: /*#__PURE__*/_jsx(Stripe, {
        height: "1rem",
        width: "70%",
        marginTop: "var(--ds-space-200, 16px)"
      })
    }) : null, /*#__PURE__*/_jsxs(PricingTierRowSkeleton, {
      children: [/*#__PURE__*/_jsx(Stripe, {
        height: "9.875rem",
        width: "9.875rem",
        borderRadius: "0"
      }), /*#__PURE__*/_jsx(Stripe, {
        height: "9.875rem",
        width: "9.875rem",
        borderRadius: "0"
      }), /*#__PURE__*/_jsx(Stripe, {
        height: "9.875rem",
        width: "9.875rem",
        borderRadius: "0"
      }), /*#__PURE__*/_jsx(Stripe, {
        height: "9.875rem",
        width: "9.875rem",
        borderRadius: "0"
      }), /*#__PURE__*/_jsx(Stripe, {
        height: "9.875rem",
        width: "9.875rem",
        borderRadius: "0"
      })]
    }), /*#__PURE__*/_jsx(PricingTierRowSkeleton, {
      children: /*#__PURE__*/_jsx(Stripe, {
        height: "3.525rem",
        width: "100%",
        marginTop: "var(--ds-space-200, 16px)"
      })
    })]
  });
};
export default PricingTiersSkeleton;